import { useState } from 'react';
import { EFrom } from 'reactApp/components/SharingNewBiz/SharingNew.types';
import { ESharingType } from 'reactApp/components/SharingWindow/Sharing.types';

export const useTabsState = ({ isSharedIncoming, from }: { isSharedIncoming: boolean; from: EFrom }) => {
    const [copiedWeblinkOnMount, setCopiedWeblinkOnMount] = useState(false);
    const [fetchedDataOnMount, setFetchedDataOnMount] = useState(false);

    const [activeTab, setActiveTab] = useState<ESharingType>(
        isSharedIncoming || from === EFrom.SHARING ? ESharingType.CLOUD_USERS : ESharingType.WEBLINK
    );

    return {
        copiedWeblinkOnMount,
        fetchedDataOnMount,
        activeTab,
        setCopiedWeblinkOnMount,
        setFetchedDataOnMount,
        setActiveTab,
    };
};
